import React, { useEffect, useState } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@mui/material';
import { TextField, FormControl, MenuItem, Select, Checkbox, Button, Alert, Snackbar  } from '@mui/material'
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import axios from 'axios'
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme)=>({
  box:{
    maxWidth:'1800px',
    margin:'0 auto',
    padding:'0 20px',

    fontFamily:[
      'Noto Sans KR'
    ],
  },
  itemAddBlockH1:{
    padding:'40px 0 20px 10px',
    fontWeight:'700',
    fontSize:'22px',
  },
  innerDiv:{
    display:'flex',
    padding:'20px 10px',
    borderBottom:'1px solid #e2e2e2',
    alignItems:'center',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      alignItems:'center',
    },
  },
  innerDivLeft:{
    width:'50%',
    display:'flex',
    alignItems:'center', 
    
    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      width:'100%',
      paddingBottom:'10px'
    },
  },
  innerDivRight:{
    width:'50%',
    display:'flex',
    alignItems:'center',

    [theme.breakpoints.down(1024)]: {
      flexDirection:'column',
      width:'100%',
    },
  },
  spanSpan:{
    width:'110px',
    fontWeight:'600',
    textAlign:'left',

    [theme.breakpoints.down(1025)]: {
      paddingBottom:'10px',
      textAlign:'center'
    },
  },
  ItemConfigLiReactQuill:{
    display:'flex',    
    padding:'0px 0 40px 10px',
    height:'400px',
    alignItems:'center',
    borderBottom:'1px solid #e2e2e2',

    [theme.breakpoints.down(1025)]: {
      flexDirection:'column',
      
    },
  },
  reactQuill:{
    width:'800px',
    height:'300px',

    [theme.breakpoints.down(1025)]: {
      width:'100%',
      height:'270px'
      
    },
  },
  itemaddTextarea:{
    width:'800px',
    height:'300px',
    border:'1px solid #ccc',

    [theme.breakpoints.down(1025)]: {
      width:'100%'
    },
  },
  inputDiv:{
    [theme.breakpoints.down(1025)]: {
      padding:'10px 0 20px 50px '
    },
  },
  btnDiv:{
    display:'flex',
    justifyContent:'center',
    marginTop:'30px',
    paddingBottom:'30px'
  },
  btnButton:{
    margin:'0 0 0 40px'
  },

}));



const ItemAdd = () => {
  const theme = useTheme();
  const classes = useStyles(theme);
  let navigate = useNavigate();

  const [errSnack, setErrSnack] = useState(false);
  const [succSnack, setSuccSnack] = useState(false);

  const [caId, setCaId] = useState('') 
  const [caId2, setCaId2] = useState('') 
  const [caId3, setCaId3] = useState('') 

  const [itId, setItId] = useState('') 
  const [itName, setItName] = useState('') 
  const [itBasic, setItBasic] = useState('') 
  const [itType1, setItType1] = useState(0) 
  const [itType2, setItType2] = useState(0) 
  const [itType3, setItType3] = useState(0) 
  const [itType4, setItType4] = useState(0) 
  const [itType5, setItType5] = useState(0) 
  const [itOrigin, setItOrigin] = useState('') 
  const [itUse, setItUse] = useState(0) 
  const [itExplan, setItExplan] = useState('') 
  const [itShopMemo, setItShopMemo] = useState('') 
  const [itPrice, setItPrice] = useState(0) 
  const [itStockQty, setItStockQty] = useState(0) 
  const [picId, setPicId] = useState(1) 
  const [colorId, setColorId] = useState(1) 
  const [itImg1, setItImg1] = useState('') 
  const [itImg2, setItImg2] = useState('') 
  const [itImg3, setItImg3] = useState('') 
  const [itImg4, setItImg4] = useState('') 
  const [itImg5, setItImg5] = useState('') 
  const [itImg6, setItImg6] = useState('') 

  const [picList, setPicList] = useState([]) 
  const [colorList, setColorList] = useState([]) 
  const [type1, setType1] = useState([])
  const [type2, setType2] = useState([])
  const [type3, setType3] = useState([])

  const getItem = async() => {
    try {
      const res = await axios.post('/api/adm/itemAddPageView/')

      if(res.data.success === false) {
        setErrSnack(true)
        return ;
      }
        setItId(res.data['it_id'])

        setPicList(res.data.picList)
        setColorList(res.data.colorList)

        setType1(res.data.cateList.filter(item => item['ca_id'].length === 2))
        setType2(res.data.cateList.filter(item => item['ca_id'].length === 4))
        setType3(res.data.cateList.filter(item => item['ca_id'].length === 6))
      
      
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
    getItem()

    return () => {
      setCaId('')
      setCaId2('')
      setCaId3('')

      setItId('')
      setItName('')
      setItBasic('')
      setItType1(0)
      setItType2(0)
      setItType3(0)
      setItType4(0)
      setItType5(0)
      setItOrigin('')
      setItUse(0)
      setItExplan('')
      setItShopMemo('')
      setItPrice(0)
      setItStockQty(0)
      setPicId(1)
      setColorId(1)
      setItImg1('')
      setItImg2('')
      setItImg3('')
      setItImg4('')
      setItImg5('')
      setItImg6('')
      setPicList([])
      setColorList([])
      setType1([])
      setType2([])
      setType3([])
    }
  } , [])



  const addItem = async() => {
    if (itName === '') return ;
    if (itImg1 === '') return ;
    let formData = new FormData()
    let ip = ''

    // try {
    //   const response = await axios.get('https://api.ipify.org?format=json');
    //   ip = response.data.ip;
    // } catch (error) {
    //   setErrSnack(true)
    //   console.error(error);
    //   return
    // }

    formData.append("it_id", itId)
    formData.append("ca_id", caId)
    formData.append("ca_id2", caId2)
    formData.append("ca_id3", caId3)
    formData.append("it_name", itName)
    formData.append("it_basic", itBasic)
    formData.append("it_type1", itType1)
    formData.append("it_type2", itType2)
    formData.append("it_type3", itType3)
    formData.append("it_type4", itType4)
    formData.append("it_type5", itType5)
    formData.append("it_origin", itOrigin)
    formData.append("it_use", itUse)
    formData.append("it_explan", itExplan)
    formData.append("it_shop_memo", itShopMemo)
    formData.append("it_price", itPrice)
    formData.append("it_stock_qty", itStockQty)
    formData.append("it_ip", ip)
    formData.append("pic_id", picId)
    formData.append("color_id", colorId)

    formData.append("it_img1", itImg1)
    formData.append("it_img2", itImg2)
    formData.append("it_img3", itImg3)
    formData.append("it_img4", itImg4)
    formData.append("it_img5", itImg5)
    formData.append("it_img6", itImg6)

    try {
      const res = await axios.post(
        '/api/adm/itemAdd/',
                            formData, 
                            {
                              headers: {
                                'Content-Type': 'multipart/form-data'
                              }
                            }
    )

      if (res.data.success === false) {
        setErrSnack(true)
      }else {
        setSuccSnack(true)
        navigate(-1);
      }
      
  
    } catch (e) {
      setErrSnack(true)
      console.log(e)
    }

  }








  const snackClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setErrSnack(false);
    setSuccSnack(false)
  };

  return (
    <div className={classes.itemAddBlock}>
      <div className={classes.box}>
        <h1 className={classes.itemAddBlockH1}>상품추가</h1>        
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>기본분류</span>
            <FormControl>
              <Select
                labelId="select-small"
                id="select-small"
                value={caId || ''}
                style={{ width:'250px' }}
                onChange={(e) => {setCaId(e.target.value)}}
              >
                {type1.length > 0 && type1.map((value, idx) => 
                              <MenuItem key={idx} value={value['ca_id']}>{`${value['ca_name']}(${value['ca_id']})`}</MenuItem>
                )}
              </Select>
            </FormControl>
          </div>
          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>2차분류</span>
            <FormControl>
              <Select
                labelId="select-small"
                id="select-small"
                value={caId2 || ''}
                style={{ width:'250px' }}
                onChange={(e) => {setCaId2(e.target.value)}}
              >
                {type2.length > 0 && type2.map((value, idx) => 
                              <MenuItem key={idx} value={value['ca_id']}>{`${value['ca_name']}(${value['ca_id']})`}</MenuItem>
                )}
              
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>3차분류</span>
            <FormControl>
              <Select
                labelId="select-small"
                id="select-small"
                value={caId3 || ''}
                style={{ width:'250px' }}
                onChange={(e) => {setCaId3(e.target.value)}}
              >
                {type3.length > 0 && type3.map((value, idx) => 
                              <MenuItem key={idx} value={value['ca_id']}>{`${value['ca_name']}(${value['ca_id']})`}</MenuItem>
                )}
              
              </Select>
            </FormControl>
          </div>
          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>상품코드</span>
            <div className={classes.dataDiv}>
              {itId}
            </div>
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>상품명</span>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              value={itName}
              onChange={(e) => {setItName(e.target.value)}}
            />
          </div>

          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>기본설명</span>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              value={itBasic}
              onChange={(e) => {setItBasic(e.target.value)}}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>히트</span>
            <Checkbox
              checked={itType1 === 0 ? false : true}
              onChange={() => {
                itType1 === 0 ?
                setItType1(1) : 
                setItType1(0)
              }}
            />
          </div>

          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>추천</span>
            <Checkbox
              checked={itType2 === 0 ? false : true}
              onChange={() => {
                itType2 === 0 ?
                setItType2(1) : 
                setItType2(0)
              }}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>신상품</span>
            <Checkbox
              checked={itType3 === 0 ? false : true}
              onChange={() => {
                itType3 === 0 ?
                setItType3(1) : 
                setItType3(0)
              }}
            />
          </div>
          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>인기</span>
            <Checkbox
              checked={itType4 === 0 ? false : true}
              onChange={() => {
                itType4 === 0 ?
                setItType4(1) : 
                setItType4(0)
              }}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>할인</span>
            <Checkbox
              checked={itType5 === 0 ? false : true}
              onChange={() => {
                itType5 === 0 ?
                setItType5(1) : 
                setItType5(0)
              }}
            />
          </div>
          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>판매가능</span>
            <Checkbox
              checked={itUse === 0 ? false : true}
              onChange={() => {
                itUse === 0 ?
                setItUse(1) : 
                setItUse(0)
              }}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>원산지</span>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              value={itOrigin}
              onChange={(e) => {setItOrigin(e.target.value)}}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          
        </div>
        <div className={classes.ItemConfigLiReactQuill}>
          <span className={classes.spanSpan}>상품설명</span>
          <ReactQuill 
            theme="snow" 
            value={itExplan}
            onChange={(content, delta, source, editor) => {setItExplan(editor.getHTML())}}
            className={classes.reactQuill} 
          />
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>상점메모</span>
          <textarea 
            name='cfInterceptIp'
            value={itShopMemo}
            onChange={(e) => {setItShopMemo(e.target.value)}}
            className={classes.itemaddTextarea}
          />
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>판매가격</span>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              type='number'
              value={itPrice}
              onChange={(e) => {setItPrice(parseInt(e.target.value))}}
            />
          </div>
          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>재고수량</span>
            <TextField 
              style={{ width:'250px' }}
              hiddenlabel="true" 
              variant="outlined" 
              type='number'
              value={itStockQty}
              onChange={(e) => {setItStockQty(parseInt(e.target.value))}}
            />
          </div>
        </div>
        <div className={classes.innerDiv}>
          <div className={classes.innerDivLeft}>
            <span className={classes.spanSpan}>관리자</span>
            <FormControl>
              <Select
                value={picId}
                onChange={(e) => {setPicId(e.target.value)}}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                style={{ width:'250px' }}
              >
                {picList.length > 0 &&
                    picList.map((item) => (
                      <MenuItem key={item['pic_id']} value={item['pic_id']}>{item['pic_name']}</MenuItem>
                    ))
                }
              </Select>
            </FormControl>
          </div>
          <div className={classes.innerDivRight}>
            <span className={classes.spanSpan}>색</span>
            <FormControl>
              <Select
                value={colorId}
                onChange={(e) => {setColorId(e.target.value)}}
                displayEmpty
                inputProps={{ 'aria-label': 'Without label' }}
                style={{ width:'250px' }}
              >
                {colorList.length > 0 &&
                    colorList.map((item) => (
                      <MenuItem 
                        key={item['color_id']} 
                        value={item['color_id']}>{item['color_name']}
                      </MenuItem>
                    ))
                }
              </Select>
            </FormControl>
          </div>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이미지1</span>
          <img />
            {typeof(itImg1) === 'string' ? itImg1 : itImg1.name}
            <div className={classes.inputDiv}>
              <input 
                type="file" 
                accept=".gif, .jpg, .jpeg, .png"
                onChange={(e) => {
                  setItImg1(e.target.files[0])
                }}
              />
            </div>
            <Button     
              variant="outlined"
              onClick={() => {setItImg1('')}}
            >
              이미지1 삭제
            </Button>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이미지2</span>
          <img />
            {typeof(itImg2) === 'string' ? itImg2 : itImg2.name}
            <div className={classes.inputDiv}>
              <input 
                type="file" 
                accept=".gif, .jpg, .jpeg, .png"
                onChange={(e) => {
                  setItImg2(e.target.files[0])
                }}
              />
            </div>
            <Button     
              variant="outlined"
              onClick={() => {setItImg2('')}}
            >
              이미지2 삭제
            </Button>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이미지3</span>
          <img />
            {typeof(itImg3) === 'string' ? itImg3 : itImg3.name}
            <div className={classes.inputDiv}>
              <input 
                type="file" 
                accept=".gif, .jpg, .jpeg, .png"
                onChange={(e) => {
                  setItImg3(e.target.files[0])
                }}
              />
            </div>
            <Button     
              variant="outlined"
              onClick={() => {setItImg3('')}}
            >
              이미지3 삭제
            </Button>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이미지4</span>
          <img />
            {typeof(itImg4) === 'string' ? itImg4 : itImg4.name}
            <div className={classes.inputDiv}>
              <input 
                type="file" 
                accept=".gif, .jpg, .jpeg, .png"
                onChange={(e) => {
                  setItImg4(e.target.files[0])
                }}
              />
            </div>
            <Button     
              variant="outlined"
              onClick={() => {setItImg4('')}}
            >
              이미지4 삭제
            </Button>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이미지5</span>
          <img />
            {typeof(itImg5) === 'string' ? itImg5 : itImg5.name}
            <div className={classes.inputDiv}>
              <input 
                type="file" 
                accept=".gif, .jpg, .jpeg, .png"
                onChange={(e) => {
                  setItImg5(e.target.files[0])
                }}
              />
            </div>
            <Button     
              variant="outlined"
              onClick={() => {setItImg5('')}}
            >
              이미지5 삭제
            </Button>
        </div>
        <div className={classes.innerDiv}>
          <span className={classes.spanSpan}>이미지6</span>
          <img />
            {typeof(itImg6) === 'string' ? itImg6 : itImg6.name}
            <div className={classes.inputDiv}>
              <input 
                type="file" 
                accept=".gif, .jpg, .jpeg, .png"
                onChange={(e) => {
                  setItImg6(e.target.files[0])
                }}
              />
            </div>
            <Button     
              variant="outlined"
              onClick={() => {setItImg6('')}}
            >
              이미지6 삭제
            </Button>
        </div>
        
        <div className={classes.btnDiv}>
          <div>
            <Button 
              variant="outlined"
              onClick={() => addItem()}
            >
              확인
            </Button>
          </div>
          <div className={classes.btnButton}>
            <Button 
              variant="outlined"
              onClick={() => navigate(-1)}
            >
              목록
            </Button>
          </div>
        </div>

      </div>



      <Snackbar 
        open={errSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="error">수행을 실패 하였습니다!</Alert>
      </Snackbar>
      <Snackbar 
        open={succSnack} 
        autoHideDuration={6000} 
        onClose={snackClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}                          
      >
        <Alert severity="success">수행을 성공 하였습니다!</Alert>
      </Snackbar> 

    </div>
  )
}

export default ItemAdd
